import { Contributors } from "../interfaces/Contributors";

export const ambassador: Contributors[] = [
  {
    id: 1,
    name: "Ana Shophia Scheller",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Buenos Aires, Argentina",
    birth: "11/07/1986",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Ana_Shophia_Scheller.jpg",
    instagram: {
      name: "la_scheller",
      url: "https://www.instagram.com/la_scheller/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Ms. Scheller was the recipient of the Mae L. Wien Award for Outstanding Promise in June 2003 Ana Sophia Scheller began dancing 
       at the age of six. At the age of nine, she started taking Ballet classes with Katty Gallo (former soloist ballet dancer at the 
       Teatro Colon) and Raul Candal (former principal ballet dancer at the Teatro Colon). She was admitted to the institution named 
       Superior de Arte del Teatro Colon in Buenos Aires at the age of 10. At the age of 13, she received a scholarship as part of Argentinas
        National Presidential Prize for Cultural Excellence in Classical Dance for three consecutive years before moving to New York. In 2000,
        she enrolled as a full time student at the School of American Ballet (SAB), the official school of New York City Ballet. At SAB MS Scheller
        performed at the 2002 and 2003 Workshop Performances dancing the principal role in Ballo della Regina and Brahms Schoenberg Quartet third 
        movement (Balanchine) and Aurora in the Wedding Pas de Deux from the Sleeping Beauty (Martins).
      </p>
      <p class="p_contributors">
      In August 2003 Ms Scheller joined American Ballet Theater Studio Company where she performed featured roles in Vertiginous Thrill of Exactitude
       (Forsythe), Symphony in C and Tarantella (Balanchine).
      </p>
      <p class="p_contributors">
       She joined New York City Ballet as a member of the corps of ballet in April 2004.In December 2006 she was promoted to soloist, and then in May 2012, 
       she was made principal with the New York City Ballet.
      </p>
     <p class="p_contributors">
       At the age of 18 she was partnered with Julio Bocca as a principal guest in his farewell world tour in Uruguay, Paraguay, Venezuela and Madrid (Spain). 
       In 2012 she guested with Teatro Massimo in Palermo for the production of Cinderella as Cinderella under de Direction of Luciano Canito.
      </p>

       <p class="p_contributors">
       She is also guest artist in many Galas around the world such as Nureyev Ballet Festival in Kazan (Russia),Gala International del Teatro Colon (Argentina),
        Gala de Ballet de Buenos Aires, Beijing International Ballet and Choreography Competition, Singapore and many more.
      </p>

        <p class="p_contributors">
       In July 2017 she joined San Francisco Ballet as a principal dancer under the direction of Helgi Tomasson.
      </p>

       <p class="p_contributors">
        Ana’s repertory includes d’Amboise’s Tribute; Balanchine’s Apollo, Ballo della Regina, Brahms-Schoenberg Quartet, Cortege Hongrois, Divertimento No. 15,
         Emeralds, The Four Temperaments, Raymonda Variations, La Sonnambula, La Source, Symphony in C, Symphony in Three Movements, Tchaikovsky Pas de Deux, 
         Tchaikovsky Piano Concerto No. 2, Tchaikovsky Suite No. 3, La Valse, Vienna Waltzes, Walpurgisnacht Ballet, and Who Cares?; Martins’ A Fool for You; 
         Ratmansky’s Concerto DSCH; Robbins’ 2 & 3 Part Inventions and Interplay; and Wheeldon’s DGV: Danse a Grande Vitesse and Estancia.
      </p>
    `,
    accomplishmentsHtml: "",
  },
  {
    id: 2,
    name: "Sally Caruso",
    education: "Dmitri Kulev Classical Ballet Academy",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "California, USA",
    birth: "11/07/1986",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Sally_Caruso.jpg",
    instagram: {
      name: "sally_caruso_dance",
      url: "https://www.instagram.com/sally_caruso_dance/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      A native Californian, Sally Caruso is a versatile, young artist who excels in multiple genres.
      </p>
      <p class="p_contributors">
       She has recently gained recognition with invitations to perform at several prestigious international dance events 
       including the YAGP Stars of Today Meet the Stars of Tomorrow Gala at the Nervi Festival in Italy, the YGP Mexico 
       International Gala in Cordoba, and most recently in the YAGP Gala at Straz Center in Tampa, FL. Additionally, she has
        also been invited to perform at the world renowned Carnegie Hall in New York City as a guest artist for acclaimed
         Japanese musician Yoshiki.
      </p>
     <p class="p_contributors">
       Sally has performed works by renowned choreographers including Mauro Bigonzetti, and will soon perform works by Ohad Naharin 
       and Shahar Binyamini as a member of the International Contemporary Ensemble at YAGP 25th Anniversary Gala at Lincoln Center. 
       A pre-professional training program student at Dmitri Kulev Classical Ballet Academy, Sally has also received numerous scholarship
        opportunities through YAGP to leading dance schools around the world.
      </p>

       <p class="p_contributors">
       Sally is thrilled and honored to be an ambassador representing Nikolay Brand.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 3,
    name: "Melanie Mcintire",
    education: "Master Ballet Academy",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Arizona, USA",
    birth: "11/07/1986",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Melanie_McIntire.jpg",
    instagram: {
      name: "melanie_mcintire",
      url: "https://www.instagram.com/melanie_mcintire/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      A native Californian, Sally Caruso is a versatile, young artist who excels in multiple genres.
      </p>
      <p class="p_contributors">
       She has recently gained recognition with invitations to perform at several prestigious international dance events 
       including the YAGP Stars of Today Meet the Stars of Tomorrow Gala at the Nervi Festival in Italy, the YGP Mexico 
       International Gala in Cordoba, and most recently in the YAGP Gala at Straz Center in Tampa, FL. Additionally, she has
        also been invited to perform at the world renowned Carnegie Hall in New York City as a guest artist for acclaimed
         Japanese musician Yoshiki.
      </p>
     <p class="p_contributors">
       Sally has performed works by renowned choreographers including Mauro Bigonzetti, and will soon perform works by Ohad Naharin 
       and Shahar Binyamini as a member of the International Contemporary Ensemble at YAGP 25th Anniversary Gala at Lincoln Center. 
       A pre-professional training program student at Dmitri Kulev Classical Ballet Academy, Sally has also received numerous scholarship
        opportunities through YAGP to leading dance schools around the world.
      </p>

       <p class="p_contributors">
       Sally is thrilled and honored to be an ambassador representing Nikolay Brand.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 4,
    name: "Morgan Ligon",
    education: "Elite Classical Coaching",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Baltimore, MD, USA",
    birth: "1/26/2011",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Morgan_Ligon.jpg",
    instagram: {
      name: "morgan__ligon",
      url: "https://www.instagram.com/morgan__ligon/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
      Morgan Leigh Ligon is a 13-year-old Baltimore, Maryland native, that developed an affinity for classical ballet at the age of 10 years old. 
      On a quest to train with a pre-professional program, Morgan and her family moved to Frisco, Texas to train with Elite Classical Coaching.
      </p>
     <p class="p_contributors">
      Since joining the pre professional ballet world in 2021, Morgan has received many accolades and opportunities. Morgan is the recipient of the 
      Youth American Grand Prix (YAGP) Hope Award for Dallas regionals 2022, 2023 and Finals 2023 competition. Morgan performed in “The Stars of Today
       Meets the Stars of Tomorrow” gala for the YAGP 2023 finals in Tampa, FL and the 25th YAGP anniversary kickoff in New York, NY.
      </p>
       <p class="p_contributors">
      Morgan is the recipient of the American Ballet Theater National Training Scholar 2022-2023 and Royal Ballet International Scholars Program.
       Morgan has received invitations and scholarships to attend summer intensives and/or short stays with some of the most renowned schools in
        the field, such as American Ballet Theater, John Cranko Schule, Houston Ballet, Princess Grace Academy and the Royal Ballet School. Morgan
         will also represent Nikolay as an ambassador.
      </p>
       <p class="p_contributors">
      Morgan is grateful for all of the opportunities that enable continuous growth in her ballet training, the ability to do what she loves daily
       and the pleasure of doing so with likeminded peers under the tutelage of amazing professionals in the field. Morgan’s goal is to join a ballet
        company that will allow her to travel the world doing what she loves.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 5,
    name: "Fabrizzio Xavier",
    education: "Escuela Superior de Música y Danza de Monterrey (ESMDM)",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "MEXICO",
    birth: "31/12/2006",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Fabrizzio_Xavier.jpg",
    instagram: {
      name: "fabrizziooou",
      url: "https://www.instagram.com/fabrizziooou/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       My name is Fabrizzio Xavier Ulloa Cornejo, I am 18 years old and I am a classical ballet dancer. I started dancing ballet at the age of 9 at the
        Escuela Superior de Música y Danza de Monterrey (ESMDM). Dancing has been my passion since I was very little, at 4 years old I started dancing jazz,
         tap, musical theater and other types of dance that made me feel happy and amused me, I started dancing ballet because I felt attracted to the beauty 
         and the magic that it expressed and now I am almost a professional dancer and I have attended competitions such as Youth America Grand Prix, where I
          have won scholarships for schools like: “Houston Ballet”, “Joffrey Ballet School” and “Academie Princess Grace”.
      </p>
     <p class="p_contributors">
     I hope to follow my dreams, to become a great professional dancer and I hope that Grishko will accompany me during this incredible adventure.
      </p>
    `,
    accomplishmentsHtml: "",
  },

  {
    id: 6,
    name: "Crystal Huang",
    education: "Bayer Ballet Academy and The Rock Center for Dance",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Fremont CA and Las Vegas NV, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Crystal_Huang.jpg",
    instagram: {
      name: "crystalhuangdance",
      url: "https://www.instagram.com/crystalhuangdance/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: ``,
    accomplishmentsHtml: `
    <ul class="list_contributors">
  <li>2024 Prix de Lausanne candidate</li>
  <li>2023 YAGP Tampa Finals Junior Bronze medalist</li>
  <li>2022 YAGP Tampa Finals Junior Bronze medalist</li>
  <li>2021 Radio City “Clara” Christmas Spectacular</li>
  <li>2023 The Dance Award (Las Vegas) Teen Best Dancer</li>
  <li>2021 The Dance Award (Las Vegas) Junior Best Dancer</li>
  <li>2019 The Dance Award (Las Vegas) Mini Best Dancer</li>
  <li>2023 NYCDA National Teen OD Winner</li>
  <li>2021 Radix Nationals Junior Core Performer Winner</li>
  <li>2019 Radix Nationals Mini Core Performer Winner</li>
  <li>2019 Showstopper National Junior Overall Winner</li>
  <li>2018 Showstopper Nationals Junior Overall Winner</li>
  <li>2019 StarPower Nationals Miss Junior and Overall Winner</li>
  <li>2017 StarPower Nationals Miss Mini and Overall Winner</li>
  <li>2018 Showbiz Nationals Pre-Junior Solo Grand Champion</li>
  <li>2018 KAR Dance Nationals Miss Junior and Overall Winner</li>
  <li>2017 KAR Dance Nationals Miss Mini and Overall Winner</li>
</ul>
    `,
  },

  {
    id: 7,
    name: "Alexei Orohovsky",
    education: "Elite Classical Coaching; John Cranko Schule",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Mississippi, USA",
    birth: "04/26/2007",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Alexei_Orohovsky.jpg",
    instagram: {
      name: "ballet_alexei",
      url: "https://www.instagram.com/ballet_alexei",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Alexei Orohovsky is 17 years old and is currently living and studying at the John Cranko Schule in Stuttgart, Germany. 
       Alexei began his training under his parents at South Mississippi Ballet Theatre at the age of eight. At 14, Alexei joined 
       Elite Classical Coaching under the direction of Catherine Lewellen for the 2021-2022 season. While there he won the silver 
       medal and the Jury Encouragement Award at the prestigious Helsinki International Ballet Competition in Finland and the Youth
        Grand Prix Award at the Youth America Grand Prix Finals.  
      </p>

      <p class="p_contributors">
        Alexei has had the opportunity to study at The Harid Conservatory, 
        Next Generation Ballet, The Royal Ballet School, and the Princess Grace Academy in Monaco. He has performed in numerous full 
        length classical ballets including The Sleeping Beauty, La Esmeralda, Swan Lake, and The Nutcracker. In the summer of 2022, 
        he was invited as a guest artist to perform at the Nervi Festival in Italy for the Stars of Today Meet the Stars of Tomorrow
        Gala and the Future of Dance Gala. He will also perform in the YAGP 25th Anniversary Kickoff Gala at Lincoln Center in April, 2023.
      </p>

       <p class="p_contributors">
         During his 1st year at the John Cranko Schule, Alexei has performed in the Aktion Weihnachten Charity Gala in December and on tour 
         with the school in Ludwigsburg. Alexei is so grateful for all of the support and mentoring he has received throughout his training 
         and dreams of becoming a Principal Dancer in a major company in the future.
      </p>
    `,
    accomplishmentsHtml: `
     <ul class="list_contributors">
    <li>Winner of the Silver Medal and Jury Encouragemnt Award at the Helsinki International Ballet Competition 2022</li>
    <li>Winner of the Youth Grand Prix Award - YAGP 2022 Finals</li>
    </ul>
    `,
  },

  {
    id: 8,
    name: "Brady Farrar",
    education: "Stars Dance Studio and The Art of Classical Ballet",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Brady_Farrar.jpg",
    instagram: {
      name: "bradyfarrar",
      url: "https://www.instagram.com/bradyfarrar/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
    <p class="p_contributors">
       Brady Farrar discovered his love of dance at the age of 5. He has called Miami home for the last 8 years where he trains at
        Stars Dance Studio and The Art of Classical Ballet. He has appeared on television on The Ellen Show, Dancing With The Stars 
        and Dance Moms. He is a five-time finals medalist at YAGP and is the current Grand Prix Winner of the North American Finals. 
        Brady is also a three-time Best Dancer Winner at The Dance Awards, the 2021 winner of the Carla Fracci Prize at Novara Dance 
        Experience, Novara, Italy, and a double gold medal winner at the South African International Ballet Competition in 2020.  
      </p>

      <p class="p_contributors">
      Brady has performed in many YAGP Galas to include the 2021 North American Finals, the 2017 Finals in the David H. Koch Theater 
      at Lincoln Center, the 2017 YAGP Mexico Festival de Danza Córdoba, and the 2016 Finals at the Brooklyn Academy of Music. He also 
      performed at the Masters and Youth Gala at the Apollo Theater in Oregon House, California, where he was honored to perform with
       Bolshoi Principals Vladislav Lantratov and Maria Aleksandrova. He is also a 2015 Gala de Danza alumni. Brady has been cast in 
       Twyla Tharp’s upcoming show Twyla Now, that will premiere at New York City Center in November.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 9,
    name: "Yana Peneva",
    education: "Ballet Conservatory at Skyra",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Florida, USA",
    birth: "08/28/2006",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Yana_Peneva.jpg",
    instagram: {
      name: "yana._.peneva",
      url: "https://www.instagram.com/yana._.peneva/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Yana Peneva began her dance training at age 2. Since 2018, Yana has been training in the pre-professional program at the Ballet Conservatory
        at Skyra in Orlando, FL where she was introduced to the ballet competition world. In the 2020-2021 season, she has been awarded with prestigious
         awards such as the Shelley King Award at YAGP finals, 1st Place Gold Medal at ADCIBC finals, 2nd Place at UBC, 2nd Place at YAGP Semi Finals Tampa,
          FL (Highest placing junior female).  
      </p>

      <p class="p_contributors">
       In 2022 Yana was honored to be awarded the Grand Prix at YAGP Tampa. She is working hard every day to reach her dreams of one day being a part of an 
       outstanding ballet, such as American Ballet Theatre, Stuttgart Ballet, Dutch National Ballet, and other dream companies.
      </p>
    `,
    accomplishmentsHtml: `
    <ul class="list_contributors">
    <li>Grand Prix Award YAGP Tampa</li>
    <li>Shelley King Award YAGP finals</li>
    <li>1st Place Gold Medal ADCIBC finals</li>
    <li>2nd Place at UBC</li>
    </ul>
    `,
  },

  {
    id: 10,
    name: "Ixan Ferrer",
    education: "Fernando Alonso National Ballet School",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "La Habana, Cuba",
    birth: "10/11/2006",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Ixan_Ferrer.jpg",
    instagram: {
      name: "ixan_ferrer",
      url: "https://www.instagram.com/ixan_ferrer/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
      <p class="p_contributors">
       Ixan began training to be a ballet dancer at the age of 5 under the tutelage of his mother. 
       At the age of 9 enrolled he enrolled at The Fernando Alonso National Ballet School in Havana,
       Cuba in 2016. In his second year there he participated and competed in the International Meeting
        Between Academies for Teaching Ballet. He was invited to the Assemble Internacionale 2023 at Canada's National
         Ballet School and recently competed at YGP México 2023 in which he received scholarships to the Royal Ballet School,
          Canada's National Ballet School, School of Nashville Ballet.
      </p>
    `,
    accomplishmentsHtml: `
    <ul class="list_contributors">
    <li>1st Place in Children's Category XXIV International Meeting of Academies for teaching Ballet 2018</li>
    <li>Award for Best Perfomance Children's Category 2018</li>
    <li>2nd Place in Children's Category XXIV International Meeting of Academies for teaching Ballet 2019</li>
    <li>2nd Place Youth Category International Meeting for teaching Ballet 2020 (Online)</li>

     <li>1st Place Youth Category International Meeting for teaching Ballet 2022</li>
      <li>1st Place Intermediate Category International Meeting for teaching Ballet 2023</li>
       <li>Special Jury Award for Technical Excellence</li>
    </ul>
    `,
  },

  {
    id: 11,
    name: "Diego Lan",
    education: "Prover Ballet & Alberta Ballet School",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Mexico",
    birth: "17/11/2005",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Diego_Lan.jpg",
    instagram: {
      name: "iancollinsartist",
      url: "https://www.instagram.com/iancollinsartist/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: ``,
    accomplishmentsHtml: `
    <ul class="list_contributors">
    <li>YAGP (Youth America Grand Prix) finalist</li>
    <li>Full-year scholarship at Alberta Ballet School</li>
    <li>Short-term scholarship at Berlin State Ballet School</li>
    <li>Short-term scholarship at Elmhurst Ballet School</li>
     <li>Full year scholarship at Colorado Ballet School</li>
      <li>Short-term scholarship at Houston Ballet School</li>
       <li>Winner of the Elisa Carrillo scholarship</li>
        <li>Third-place winner in ensembles at YAGP 2023.</li>
    </ul>
    `,
  },

  {
    id: 12,
    name: "Isabella Keesee",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "TX, USA",
    birth: "11/25/2008",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Isabella_Keesee.jpg",
    instagram: {
      name: "izzy_lovesdance",
      url: "https://www.instagram.com/izzy_lovesdance/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: ``,
    accomplishmentsHtml: `
    <ul class="list_contributors">
    <li>The Senior Grand Prix award at Youth America Grand Prix</li>
    <li>2024 Candidate for the Prix de Lausanne</li>
    </ul>
    `,
  },

  {
    id: 13,
    name: "Alicia Heyer",
    education: "Ballet West Academy, Olympic Ballet School",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Seattle, Washington and Nagano, Japan",
    birth: "06/29/2006",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Alicia_Heyer.jpg",
    instagram: {
      name: "alicia.heyer2",
      url: "https://www.instagram.com/alicia.heyer2/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
    <p class="p_contributors">
        Hello, my name is Alicia Heyer and I am 17 years old. I have been dancing since I was very young and started training seriously in classical 
        ballet around the age of nine when I knew that ballet was what I wanted to pursue. I have been trained at Olympic Ballet School in Edmonds, 
        Washington and Ballet West Academy in Salt Lake CIty, Utah.
      </p>

      <p class="p_contributors">
      This past summer at the Bolshoi Ballet Academy Summer Intensive I was honored to be 
        selected by A.S.E Global Bridges to be a Nikolay Ambassador. I look forward to all that ballet has in store for me in the future. On top of ballet 
        I love reading, music, and photography.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 14,
    name: "Ethan Maas",
    education: "Cary Ballet Conservatory",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "NC, USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Ethan_Maas.jpg",
    instagram: {
      name: "ethanmaasballet",
      url: "https://www.instagram.com/ethanmaasballet/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
    <p class="p_contributors">
        Ethan Maas is 18 years old and is currently training at Cary Ballet Conservatory in Cary, North Carolina. Ethan began dancing at the age of twelve in his hometown of Lexington, Kentucky. At the age of fifteen, Ethan moved to North Carolina where he has been training at Cary Ballet Conservatory, under the direction of Mariaelena Ruiz, for the last three years. Ethan is in his final year of pre-professional training and is looking forward to beginning his professional dance career.
      </p>

      <p class="p_contributors">
    During his time as a student, Ethan has had the privilege of learning the principal role in Balanchine’s Who Cares. Balanchine’s Serenade (Staged by Suzanne Farrell), Nutcracker (Cavalier, Russian Lead), Copelia (Franz), Don Quixote (Soloist), The Lion, the Witch and the Wardrobe (Peter), Originated role in Flick of the Wrist by Jill Bahr, Principal role in Bonjour le Monde by Maria Konrad. He has performed contemporary works by Maria Konrad, Krista King-Doherty, Andrea Astuto, Mimmo Miccolis, Ohad Naharin, and Kinsun Chan.
      </p>
    `,
    accomplishmentsHtml: `
    <ul class="list_contributors">
        <li>2024, 2023, 2022, 2021 YAGP Finals</li>
        <li>2024, 2023 Prix de Lausanne Candidate</li>
        <li>2023 YGP Festival Mexico Guest Artist Stars of Today Meet Stars of Tomorrow Gala</li>
        <li>2023 USA/IBC Competitor</li>
        <li>2023 YAGP Winston Salem Regional 1st Place</li>
        <li>2023 YAGP Paris 6th Place</li>
        <li>2022 YAGP Nervi Festival/li>      
    </ul>
    `,
  },

  {
    id: 15,
    name: "Paris Svigos",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "IL, USA",
    birth: "11/01/2006",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Paris_Svigos.jpg",
    instagram: {
      name: "svigosparis",
      url: "https://www.instagram.com/svigosparis/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
    <p class="p_contributors">
     Paris Svigos was born and raised in Chicago, Illinois she is currently studying at IllinoisClassicalBallet and has been with 
     her teacher Ms.Stella since she was 8! She has performed variations such as La Esmeralda, Grand Pas Classique, Satenella, Cupid
      Cubana and has competed on YAGP stage since she was 10!
      </p>

       <p class="p_contributors">
        Danced pieces and worked with choreographers such as Maria Konrad, Goyo Monteros “DÜRER DOG “for Nervi YAGP festival, Mauro Bigonzetti’s 
       “Rossini Cards” for Nervi YAGP festival and will soon be in New York performing with ICE in Shahar Binyamini’s “Bolero”
      </p>

       <p class="p_contributors">
       Hoping to become a Professional ballet dancer and share my passion and love for the art and all it has done for me with others and be able to 
       inspire the next generation!
      </p>

    `,
    accomplishmentsHtml: `
    <ul class="list_contributors">
        <li>YAGP Grand prix award</li>
        <li>YAGP Youth Grand prix award</li>
        <li>YAGP Mexico International Gala</li>
        <li>YAGP Nervi Stars of today meet stars of tomorrow performing Esmerelda</li>
        <li>YAGP upcoming Gala performance in NYC with ICE</li>
        <li>YAGP Finals ‘18-‘23</li>
    </ul>
    `,
  },

  {
    id: 16,
    name: "Athena Shevorykin",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Athena_Shevorykin.jpg",
    instagram: {
      name: "athena_ballerina_",
      url: "https://www.instagram.com/athena_ballerina_/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Athena Shevorykin has been a student at the School of American Ballet since 2016. She has participated in multiple New York City Ballet productions, 
      including Swan Lake, A Midsummer Night’s Dream, and multiple roles, including the lead role of Marie, in The Nutcracker. She has also participated in
      numerous School of American Ballet performances, such as the Toulmin Choreography Workshop and 90th Anniversary Ball, and she is a member of the SAB Honor Society.
      Athena was selected as a Nikolay Ambassador after attending the Bolshoi Ballet Academy Summer Intensive program in 2023.
      </p>

    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 17,
    name: "Keenan Mentzos",
    education: "Ballet Bloch Canada",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Canada",
    birth: "03/31/2009",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Keenan_Mentzos.jpg",
    instagram: {
      name: "keenan_mentzos",
      url: "https://www.instagram.com/keenan_mentzos/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Keenan was born and raised in Vancouver, Canada and started taking his first dance classes at the age of 8, where he trained in a wide range of styles,
      from jazz to hip-hop, contemporary, and acro to ballet. Along with dance, he also pursued musical theatre and acting but at the age of 13, he chose to
      focus solely on Ballet and began his formal pre-professional training.
      </p>

     <p class="p_contributors">
      While training, Keenan participated in the Youth America Grand Prix and was awarded many trophies and full scholarships to prestigious ballet institutes worldwide.
      </p>

      <p class="p_contributors">
       Most recently, Keenan was awarded the Gold Medal in the Junior Men’s category at the YAGP finals in New York City and invited to perform in the Starts of Today Meet 
       the Stars of Tomorrow Gala at the David Koch Theatre.
      </p>

        <p class="p_contributors">
       Currently, Keenan trains at Bloch Ballet Canada in his hometown of Vancouver and will be joining the Royal Ballet School in 2024/25.
      </p>

    `,
    accomplishmentsHtml: `
        <ul class="list_contributors">
        <li>2024 YAGP FINALS JR MENS GOLD MEDAL</li>
        <li>2024 YAGP YOUTH GRAND PRIX MEDAL</li>
        <li>2024 YAGP FINALS Stars of Today meet Stars of Tomorrow Performances</li>
        <li>2023 YAGP NERVI Stars of Today meet Stars of Tomorrow Performances</li>
        <li>2023 YAGP ICE Contemporary Performances</li>
        <li>2024 ROYAL BALLET SCHOOL INTERNATIONAL SCHOLAR</li>
        <li>YAGP Finalist ‘20-‘24</li>
        <li>2022 The Dance Awards Junior Best Dancer Trophy</li>
        <li>2021 The Dance Awards Mini Best Dancer Trophy</li>
    </ul>
    `,
  },

  {
    id: 18,
    name: "Viktoria Papakalodouka",
    education: "Ballet Bloch Canada",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Greece",
    birth: "03/30/2008",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Viktoria_Papakalodouka.jpg",
    instagram: {
      name: "viktoriapapakalodouka",
      url: "https://www.instagram.com/viktoriapapakalodouka/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Viktoria Papakalodouka is 16 years old and she is from Athens, Greece. Viktoria first had a ballet class when she was 5 years old. 
      She immediately fell in love with it and later when she turned 9, her family and she moved to New York, USA for it.
      </p>`,
    accomplishmentsHtml: `
       <strong class="list_subtitle">Since Viktoria has moved to the United States</strong>
      <ul class="list_contributors">
        <li>She attended her very first ballet competition: ADC IBC St. Petersburg Finals in which she won the Junior Grand Prix Award in 2023.</li>
        <li>In January 2024, Viktoria participated in the YAGP Tampa semi-finals in which she received 1st place in classical.</li>
        <li>In January 2024, Viktoria was selected and competed in Prix De Lausanne Competition in Lausanne, Switzerland, where only 44 girls around the world were selected to participate.</li>
        <li>In April 2024, Viktoria participated in the YAGP 25th Anniversary Finals in which she won the Natalia Makarova for Artistry, as well as placing Top 12 in the Senior Category.</li>
      </ul>
    <strong class="list_subtitle">Galas and other events</strong>
     <ul class="list_contributors">
        <li>In October 2023 Viktoria was invited and participated in the YGP Mexico Stars of Today meet the Stars of Tomorrow gala in Cordoba, Mexico.</li>
        <li>Also in October 2023, she was invited and performed an excerpt of Swan Lake in the Yoshiki 10th Classical World Tour with the orchestra REQUIEM in Carnegie Hall in New York, NY.</li>
        <li>In January 2024, Viktoria was invited and performed in the YAGP Stars of Today Meet the Stars of Tomorrow Gala where she performed the Gamzatti variation from La Bayadere.</li>
        <li>In March 2024 she was invited and performed in the ADC IBC Finals Gala in St. Petersburg, Florida where she performed the Gamzatti variation.</li>
      </ul>

      <p class="p_contributors">
     Viktoria is so thankful for all the opportunities and support she has had. She is grateful for all her training that is letting her grow and reach her goal of becoming a professional dancer in a ballet company.
      </p>
    `,
  },

  {
    id: 19,
    name: "Betty Pan",
    education: "John Cranko School, Li’s Ballet Studio",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Betty_Pan.jpg",
    instagram: {
      name: "_bettypan_",
      url: "https://www.instagram.com/_bettypan_/",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
     Betty Pan started her ballet training when she was 5 years old at Li’s Ballet Studio. At 12 years old, she discovered her love for ballet
      and began training professionally under Zhang Li, director of Li’s Ballet Studio in Los Angeles, California. She has won many awards such
       as 1st Place at YAGP Semi Finals, 2nd Place at YAGP Semi Finals, and numerous scholarships to prestigious schools around the world, such 
       as John Cranko School, Ellison Ballet School, Houston Ballet, The Rock School for Dance Education, Vaganova Ballet Academy, and Bolshoi Ballet Academy.
      </p>

        <p class="p_contributors">
        Betty Pan received a scholarship at 14 years old to attend the John Cranko School in Stuttgart Germany and trained under Maria Eichwald for two years
        and had the opportunity to learn with the Stuttgart Ballet Company during their performances.
      </p>

    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 20,
    name: "Elizabeth Gray Rivers",
    education: "Ann Brodie's Carolina Ballet Center",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Elizabeth_Gray_Rivers.jpg",
    instagram: {
      name: "elizabeth_gray_rivers",
      url: "https://www.instagram.com/elizabeth_gray_rivers",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Elizabeth-Gray Rivers has studied ballet for 13 years with Ann Brodie’s Carolina Ballet Center for Dance Education under the direction of Mimi Worrell,
       Ashley Lindler, Sakura Oka, Ashley Concannon and Leonardo Victorino and is a Senior company member of Ann Brodie’s Carolina Ballet.
      </p>

      <p class="p_contributors">
       She has attended multiple summer programs around the United States such as School of American Ballet summer intensive, Miami City Ballet School summer intensive,
        Duncan Cooper summer workshop, Houston Ballet summer intensive, Cary Ballet Conservatory winter intensive and Cary Ballet Prix Challenge as well as Canada’s National 
        Ballet School.
      </p>

      <p class="p_contributors">
       Elizabeth-Gray has placed 3rd at Universal Ballet Competition in 2019, 2020, 2022, and 2024 as well as 3rd at Youth American Grand Prix in 2020 and top 10 at ADC-IDC in 2024.
        She has placed 1st at South Carolina Governor’s School Grand Jete competition in 2023 and 2024. Elizabeth-Gray has dreams of dancing professionally in a ballet company. 
        She is grateful and honored to be representing Nikolay as an ambassador!
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 21,
    name: "Afina Gosla",
    education: "Southland Ballet Academy",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Afina_Gosla.jpg",
    instagram: {
      name: "afina_gosla",
      url: "https://www.instagram.com/afina_gosla",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
       Afina is a native of Southern California. Afina has been at Southland Ballet Academy since the age of 4 and is currently in the Pre-Professional
        Training program under the guidance of Ms. Salwa Rizkalla. She has performed various roles in The Festival Ballet’s productions of Don Quixote, 
        Swan Lake, Coppelia and the yearly production of The Nutcracker, performing as Clara in 2024.
      </p>

      <p class="p_contributors">
      Afina has competed in the Youth America Grand Prix since 2020. She has won many awards and received scholarships from well renowned Ballet schools around
       the world including: The Royal Ballet School, John Cranko Schule, Bolshoi Ballet Academy, Princess Grace Academy in Monaco, European School of Ballet,
        Dutch National Ballet Academy, Academia Teatro Alla Scala and American Ballet Theatre.
      </p>

      <p class="p_contributors">
       Afina is honored and excited to be part of the Nikolay Ambassador program. She hopes to become a Professional Ballet Dancer and share her
        love of dance with the world.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 22,
    name: "Skylar Chu Robin",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Skylar_Chu_Robin.jpg",
    instagram: {
      name: "the.ballet.twins",
      url: "https://www.instagram.com/the.ballet.twins",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
        Skylar Chu Robin is from Los Angeles, CA. She has been seriously pursuing Ballet since she was 10 years old. Her training has taken her from her home in California
        to renowned summer intensives at places such as The Royal Ballet School in London, The Académie Princesse Grace in Monaco, The Prix de Lausanne Preselection in Villars,
        Switzerland, and The Bolshoi Ballet in NYC. She has been a guest artist with her identical twin sister Mackenzie at the YGP “Stars of Today Meet the Stars of Tomorrow
        Gala” at the Nervi Music and Ballet Festival in Italy the past 3 years, as well as a guest artist for the YGP Galas in Cordoba, Mexico, Sicily, Italy and the YAGP
        Gala at Lincoln Center in NYC for the last 2 years. She is also a part of the International Contemporary Ensemble and performed “Bolero X” by Shahar Binyamini
        in Amsterdam, Netherlands, Genoa, Italy, and Sicily, Italy.
      </p>

      <p class="p_contributors">
       Skylar finished in 1st place at the YAGP Senior Classical Semi-Final in New York, and has had multiple 2nd and 3rd place finishes as well. She and Mackenzie have 
       finished in 1st place for multiple YAGP Small Ensemble semi-finals for their duets together, and finished 2nd at the 2024 YAGP Small Ensemble Finals in NYC at Lincoln 
       Center for their piece “Apparition” choreographed by Brady Farrar.
      </p>

      <p class="p_contributors">
      Skylar is very excited and honored to be representing Nikolay as an Ambassador, and looks forward to being a part of this prestigious program.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 23,
    name: "Mackenzie Chu Robin",
    education: "",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Mackenzie_Chu_Robin.jpg",
    instagram: {
      name: "the.ballet.twins",
      url: "https://www.instagram.com/the.ballet.twins",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
        Mackenzie Chu Robin is from Los Angeles, CA. She has been seriously pursuing Ballet since she was 10 years old. Her training has taken her from her home in California
         to prestigious summer intensives such as The Royal Ballet School in London, The Académie Princesse Grace in Monaco, The Prix de Lausanne Preselection in Villars, 
         Switzerland, and The Bolshoi Ballet in NYC. She has been a guest artist with her identical twin sister Skylar at the YGP “Stars of Today Meet the Stars of Tomorrow 
         Gala” at the Nervi Music and Ballet Festival in Italy the past 3 years, as well as a guest artist for the YGP Galas in Cordoba, Mexico, Sicily, Italy and the YAGP 
         Gala at Lincoln Center in NYC for the last 2 years. She is also a part of the International Contemporary Ensemble and performed “Bolero X” by Shahar Binyamini in
         Amsterdam, Netherlands, Genoa, Italy, and Sicily, Italy.
      </p>

      <p class="p_contributors">
       Mackenzie finished in 1st place at the YAGP Sr. Classical Semi-Final at Huntington Beach, CA and participated in the Final Round at the YAGP Finals in 2023. She and 
       Skylar have finished in 1st place for multiple YAGP Small Ensemble semi-finals for their duets together, and finished 2nd at the 2024 YAGP Small Ensemble Finals in 
       NYC at Lincoln Center for their piece “Apparition” choreographed by Brady Farrar.
      </p>

      <p class="p_contributors">
       This is Mackenzie’s first year as a Nikolay Ambassador, and she is thrilled and honored to be part of the family.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 24,
    name: "Ekaterina Pichkova",
    education: "Osipova Ballet Academy",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "02/03/2010",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Ekaterina_Pichkova.jpg",
    instagram: {
      name: "pichkova.katya",
      url: "https://www.instagram.com/pichkova.katya",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
        Ekaterina was raised in Mountain View, California, where she first began taking dance classes at the age of 6. At the age of 8, Ekaterina began 
        training pre-professionally in the Vaganova Method under the guidance of Marina Osipova.
      </p>

      <p class="p_contributors">
      Ekaterina is the recipient of numerous prestigious awards, prizes, & scholarships. She has been awarded the prestigious YAGP Youth Grand Prix Award, 
      YGP Italy 1st Place Classical Prize, as well as 1st, 2nd, & 3rd Place Awards in both the Classical & Contemporary Categories. She was awarded Top 12 
      Junior Women at the 25th Anniversary Season Finals of YAGP in NYC, performing in the Final Round at the David H. Koch Theatre at Lincoln Center. 
      In 2022, & 2023 Ekaterina placed Top 24 at the YAGP Tampa International Finals. Ekaterina has also had the honor of performing at the YAGP
       “Stars of Today Meet the Stars of Tomorrow” & “Future of Dance” International Galas in Nervi, Italy as well as the YAGP “Evolution of a Dancer” 
       Gala in San Francisco, California. She is also a 2x VKIBC Gold Medalist, & CDC 4x Gold Medalist.
      </p>

      <p class="p_contributors">
       Ekaterina has been awarded various scholarships through YAGP to attend short term/summer intensive programs at some of the world’s most prestigious institutions
        including the John Cranko Schule, Princess Grace Academie, Dutch National Ballet Academy, San Francisco Ballet School, Zurich Dance Academy, Berlin Ballet School,
         & Bolshoi Ballet Academy.
      </p>

      <p class="p_contributors">
       Ekaterina is very honored to receive invaluable training & mentoring from industry leading professionals, incredible people & inspiring artists. 
       She cherishes all the amazing opportunities & experiences she has been provided with and is honored to become a Nikolay Grishko Ambassador sharing 
       her love & passion for the art of dance as well as the Nikolay Grishko brand!
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 25,
    name: "Mateo Daukaus",
    education: "Ballet West Academy",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "USA",
    birth: "",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Mateo_Daukaus.jpg",
    instagram: {
      name: "mateodaukaus",
      url: "https://www.instagram.com/mateodaukaus",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Mateo Daukaus started his training at Metropolitan Ballet Academy in Philadelphia, Pennsylvania, training in ballet, modern dance, and folk dance.
      At the age of 12, Mateo began studying in the Cuban method under the Sarasota Cuban Ballet School with Ariel Serrano and Wilmian Hernandez.
      While there, he trained with Tania Vergara and learned a wide variety of classical repertoire. He has performed such roles as the male lead of La Esmeralda,
      the Nutcracker Soldier, Satanella, Paquita, and Coppelia. 
      </p>

      <p class="p_contributors">
      He has also received awards from the Youth American Grand Prix and scholarships to American Ballet
      Theatre, John Cranko School, European School of Ballet, and Ballet West. Now, Mateo is dancing in the Preprofessional Training Division at Ballet West.
      </p>
    `,
    accomplishmentsHtml: ``,
  },

  {
    id: 26,
    name: "Santino Herrera",
    education: "Cary Ballet Conservatory",
    category: "Nikolay Ambassadors",
    market: "Nikolay Brand Ambassador",
    country: "Argentina",
    birth: "10/01/2008",
    image:
      "https://yzlbdstwuaznspepvtyo.supabase.co/storage/v1/object/public/nikolay/Ambassadors/Santino_Herrera.jpg",
    instagram: {
      name: "santiherreraballet",
      url: "https://www.instagram.com/santiherreraballet",
    },
    company: {
      logo: "",
      name: "",
      office: "",
      address: "",
      tel: "",
      website: "",
      instagram: {
        name: "",
        url: "",
      },
    },
    descriptionHtml: `
     <p class="p_contributors">
      Santino Benjamin Herrera, born in Argentina, began his dance training at the age of 13 at Danza Andrea Montero in Salta, Argentina. 
      Showing rapid progress and passion for ballet, at the age of 15, Santino was awarded a full scholarship by Director Mariaelena Ruiz
       to join Cary Ballet Conservatory’s Professional Training Program in North Carolina, USA.
      </p>

      <p class="p_contributors">
      Since joining Cary Ballet Conservatory, Santino has established himself as a rising talent on the international stage. He has participated in
       prestigious competitions, including the Youth America Grand Prix (YAGP), the American Dance Competition | International Ballet Competition
      (ADC|IBC), and the Prix de Lausanne.
      </p>

      <p class="p_contributors">
      In 2024, Santino achieved significant recognition: he won first place in Senior Classical at the YAGP semi-finals in Winston-Salem, NC; 
      earned second place in both Senior Classical and Contemporary at ADC|IBC semi-finals in Raleigh, NC; and advanced to the final round of 
      YAGP Finals at Lincoln Center in New York City. At ADC, he reached the final rounds and secured a spot in the Top 10.
      </p>

      <p class="p_contributors">
      In 2025, Santino’s accomplishments grew even further. He was selected as a Prix de Lausanne candidate, representing Cary Ballet Conservatory. 
      At ADC|IBC semi-finals in Winston-Salem, he won first place in Senior Classical and second place in Senior Contemporary. At the YAGP semi-finals 
      in Raleigh, NC, he again earned first place in Senior Classical and second place in Senior Contemporary.
      </p>

      <p class="p_contributors">
      At ADC Finals, Santino reached the pinnacle of success: he advanced to the final rounds, won first place in his category, earned the highest overall 
      score among both male and female dancers, and was awarded the prestigious Fernando Bujones Recognition Prize.
      </p>

      <p class="p_contributors">
      At YAGP Finals, Santino placed in the Top 12 in the Men’s Category as well as the Top 12 in Pas de Deux. His talent earned him multiple gala invitations
       for both YAGP and ADC|IBC, with performances in St. Petersburg, Tampa, New York City, and Lake Como.
      </p>

      <p class="p_contributors">
      As a result of the scholarship he was awarded during his participation at the Prix de Lausanne, Santino will be joining the Royal Ballet in London, 
      where he will continue his training and pursue the next stage of his professional career.
      </p>
    `,
    accomplishmentsHtml: ``,
  },
];
